
    <div style="display: flex;
    justify-content: center;">
      <h1 mat-dialog-title style="text-align:center;">Thermal Required?</h1>
    </div>
    <div style="display: flex;
    justify-content: center;">
      <button mat-button (click)="dialogRef.close(1)"  style="border: 0;
    height: 40px;
    width: 100px;
    margin: 10px;">Yes</button>
      <button mat-button (click)="dialogRef.close(2)"  style="background: #ffffffaf;
    border: 0;
    height: 40px;
    margin: 10px;
    width: 100px;">No</button>
    </div>
  